import TOC_TYPES from '../../constants/tocTypes';

export default function isExercise(tocItem) {
  return [TOC_TYPES.MCQ].some((type) => type === tocItem.type);
}
